import React, { useContext } from "react";

import { Star } from "@mui/icons-material";
import { Box, IconButton, useTheme } from "@mui/material";

import useTruncateString from "hooks/useTruncateString";
import { handleAdd, handleRemove } from "utils/helpers";
import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function FavoriteSong({ trackName }) {
  const { favSongs, setFavSongs } = useContext(UserContext);

  const mainTheme = useTheme();

  const handleTruncatedString = useTruncateString();

  return (
    <Box>
      <Box
        component="article"
        sx={{
          display: "block",
          padding: "5px",
          margin: "10px",
          borderRadius: "1.25rem",
          backgroundColor: mainTheme.palette.blackSecondary.main,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: ".70rem",
            margin: "5px",
            justifyContent: "space-between",
          }}
        >
          {handleTruncatedString({
            customText: trackName,
            customVariant: "h6",
            customComponent: "p",
            customSx: {
              paddingRight: "1rem",
            },
            maxCharacters: {
              sm: 13,
              smToMd: 38,
              aboveMd: 66,
            },
          })}
          <IconButton
            onClick={() => {
              if (!favSongs.includes(trackName)) {
                handleAdd(trackName, favSongs, setFavSongs);
              } else {
                handleRemove(trackName, setFavSongs);
              }
            }}
            sx={{
              borderColor: mainTheme.palette.darkPinkPrimary.main,
              borderRadius: "50%",
              borderWidth: "2px",
              borderStyle: "solid",
              width: "2.5rem",
              height: "2.5rem",
              backgroundColor: favSongs.includes(trackName)
                ? mainTheme.palette.darkPinkPrimary.main
                : mainTheme.palette.blackPrimary.main,
              "&:hover": {
                bgcolor: mainTheme.palette.darkPinkPrimary.dark,
              },
            }}
          >
            <Star sx={{ color: mainTheme.palette.whitePrimary.main }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

FavoriteSong.propTypes = {
  trackName: PropTypes.string.isRequired,
};

export default FavoriteSong;
